import { useEffect } from "react";

import "./Live_projects.css";
import { LiveProjects } from "../../constants/cse_dept";
import {
  Backtotop,
  Floatinmenu,
  Csedept_Project_Card,
} from "../../widgets";

import {
  cse_dept_menu,
} from "../../constants/cse_dept";

import { FaComputer } from "react-icons/fa6";

import { RadialMenu} from "../../components";

const Live_projects = () => {
  useEffect(() => {
    document.title = "ACCET-CSE | Live Projects";
  }, []);

  return (
    <div className="csedept">
      <div className="csebg">
        <div className="cseheading">
          Department of Computer Science and Engineering
        </div>
        <div className="cse_sub_heading">Live Projects</div>
      </div>
      <section className="csedark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={cse_dept_menu} />
        </div>
        <RadialMenu menu_links={cse_dept_menu} />
        
        {LiveProjects.map((project, index) => (
  <Csedept_Project_Card key={index} {...project} />
))}

      </section>

      <Backtotop />
    </div>
  );
};

export default Live_projects;
